import React from "react";
import "../styles/link-tree.css";
import "../index.css";

export const LinkTree = () => {
  return (
    <>
      <div className="link-tree-grid">
        <div className="spacer"></div>
        <div className="tree-container">
          <h2 className="s24px-red">Add me to the URL</h2>
          <select name="link-tree" id="link-tree">
            <option value="account-created">/account-created </option>
            <option value="landing">/</option>
            <option value="link-social">/link-social</option>
            <option value="media-added">/media-added</option>
            <option value="register">/register</option>
            <option value="sign-in">/sign-in</option>
            <option value="settings">/settings</option>
          </select>
        </div>
      </div>
    </>
  );
};
